import {OrderDirectionType, SortUiState} from './SortUiState.model';

export enum BANK_ACCOUNTS_ALLOWED_ORDER_BY {
  Entity = 'Entity',
  EntityName = 'EntityName',
  Type = 'Type',
  Country = 'Country',
  DateAdded = 'Date',
  Balance = 'Balance',
  ConnectedStatus = 'ConnectedStatus',
}

export class BankAccountsUiState {
  private static ORDER_BY_DEFAULT: string = BANK_ACCOUNTS_ALLOWED_ORDER_BY.ConnectedStatus;
  private static DIRECTION_DEFAULT: OrderDirectionType = 'desc';

  public sort: SortUiState;

  constructor() {
    this.sort = {
      orderBy: BankAccountsUiState.ORDER_BY_DEFAULT,
      direction: BankAccountsUiState.DIRECTION_DEFAULT
    };
  }

  static fromJson(contactsObj: any): BankAccountsUiState {
    const model = new BankAccountsUiState();
    if (contactsObj && contactsObj.sort) {
      model.sort = {
        orderBy: contactsObj.sort.orderBy || BankAccountsUiState.ORDER_BY_DEFAULT,
        direction: contactsObj.sort.direction || BankAccountsUiState.DIRECTION_DEFAULT
      };
    }
    return model;
  }
}
